import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { CommonModule, DatePipe } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { HabilitacaoRoutingModule } from './habilitacao-routing.module';
import { HabilitacaoPesquisaComponent } from './pesquisa/habilitacao-pesquisa.component';
import { HabilitacaoListagemComponent } from './pesquisa/listagem/habilitacao-listagem.component';
import { SelectCotistaComponent } from './select-cotista/select-cotista.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NovaSubscricaoCotaComponent } from './subscricao-cotas/nova-subscricao-cota/nova-subscricao-cota.component';
import { EdicaoSubscricaoCotaComponent } from "./subscricao-cotas/edicao-subscricao-cota/edicao-subscricao-cota.component";
import { BnPipeCnpj } from "@bndes/bndes-ux4/bn-mask2/cpfcnpj";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { ConglomeradoPesquisaComponent } from './conglomerado/pesquisa/conglomerado-pesquisa.component';
import { ConglomeradoListagemComponent } from './conglomerado/pesquisa/listagem/conglomerado-listagem.component';
import { NovoConglomeradoComponent } from './conglomerado/novo-conglomerado/novo-conglomerado.component';
import { LabelConglomeradoDicaComponent } from './conglomerado/label-conglomerado-dica/label-conglomerado-dica.component';
import { PercentPipe } from '@angular/common';
import { NovoPatrimonioLiquidoComponent } from './patrimonio-liquido/novo-patrimonio-liquido/novo-patrimonio-liquido.component'
import { PatrimonioLiquidoPesquisaComponent } from './patrimonio-liquido/pesquisa/patrimonio-liquido-pesquisa.component';
import { PatrimonioLiquidoListagemComponent } from './patrimonio-liquido/pesquisa/listagem/patrimonio-liquido-listagem.component';
import { SubscricaoCotasListagemComponent } from './subscricao-cotas/subscricao-cotas-pesquisa/listagem/subscricao-cotas-listagem.component';
import { SubscricaoCotasPesquisaComponent } from './subscricao-cotas/subscricao-cotas-pesquisa/subscricao-cotas-pesquisa.component';
import { NovaHabilitacaoAlternativaComponent } from './habilitacao-alternativa/nova-habilitacao-alternativa/nova-habilitacao-alternativa.component';
import { HabilitacaoAlternativaPesquisaComponent } from './habilitacao-alternativa/pesquisa-habilitacao-alternativa/habilitacao-alternativa-pesquisa.component';
import { HabilitacaoAlternativaListagemComponent } from './habilitacao-alternativa/pesquisa-habilitacao-alternativa/listagem/habilitacao-alternativa-listagem.component';

@NgModule({
  declarations: [
    HabilitacaoPesquisaComponent,
    HabilitacaoListagemComponent,
    SelectCotistaComponent,
    NovaSubscricaoCotaComponent,
    EdicaoSubscricaoCotaComponent,
    ConglomeradoPesquisaComponent,
    ConglomeradoListagemComponent,
    NovoConglomeradoComponent,
    LabelConglomeradoDicaComponent,
    ConglomeradoListagemComponent,
    NovoPatrimonioLiquidoComponent,
    PatrimonioLiquidoPesquisaComponent,
    PatrimonioLiquidoListagemComponent,
    SubscricaoCotasListagemComponent,
    SubscricaoCotasPesquisaComponent,
    NovaHabilitacaoAlternativaComponent,
    HabilitacaoAlternativaPesquisaComponent,
    HabilitacaoAlternativaListagemComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    BnConfirmDirective,
    HabilitacaoRoutingModule,
    ReactiveFormsModule,
    NgSelectModule,
  ],
  providers: [
    BnPipeCnpj,
    PercentPipe
  ],
})
export class HabilitacaoModule { }
